import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import { Field } from "formik"; // Assuming you're using Formik
import GetAddressInfo from "../../hooks/GetAddressInfo";

const EnquiryNine = ({
  handleSwithCases,
  setFieldValue,
  errors,
  touched,
  values,
}) => {
  const { addressData, getAddress } = GetAddressInfo(); // Ensure this hook is properly implemented

  // Function to handle the search click event
  const handleSearchClick = (postCode) => {
    if (postCode) {
      getAddress(postCode); // Fetch address data based on the post code
    }
  };

  useEffect(() => {
    if (values?.postCode) {
      getAddress(values?.postCode); // Trigger the getAddress function with the initial postCode
    }
  }, [values?.postCode]); // Only re-run when postCode changes

  useEffect(() => {
    if (values?.postCode) {
      setFieldValue("latitude", addressData?.latitude || 0);
      setFieldValue("longitude", addressData?.longitude || 0);
    }
  }, [values?.postCode, addressData]); // Only re-run when postCode changes

  return (
    <>
      <div>
        <div className="account-created-pop">
          <h3>Your Location</h3>
          <p>What’s the location of the job?</p>
          <Row>
            <Col lg={12} className="mx-auto">
              {/* Post Code Input Field */}
              <Form.Group className="mb-3" controlId="formBasicPostCode">
                <Form.Label>Post Code</Form.Label>
                <div className="pre-registration-form cmn-form-set">
                  <Form.Control
                    type="text"
                    placeholder="Type here"
                    name="postCode"
                    value={values.postCode}
                    onChange={(e) => {
                      const upperCaseValue = e.target.value.toUpperCase();
                      setFieldValue("postCode", upperCaseValue);
                    }}
                  />
                  <button
                    type="button"
                    onClick={() => handleSearchClick(values.postCode)}
                  >
                    Search
                  </button>
                </div>

                {touched.postCode && errors.postCode && (
                  <div className="error-message">{errors.postCode}</div>
                )}
              </Form.Group>

              {/* Address Selection Dropdown */}
              <Form.Group
                className="mb-3 cmn-form-set"
                controlId="formBasicAddress"
              >
                <Form.Label>Confirm Your Address</Form.Label>
                <Field
                  as="select"
                  name="address"
                  className="form-control"
                  value={values.address}
                >
                  <option value="">Select Address</option>
                  {addressData?.addresses?.map((item, index) => (
                    <option
                      key={index}
                      value={item?.formatted_address
                        ?.filter((line) => line.trim() !== "")
                        .map((line) =>
                          line
                            .split(",")
                            .map((word) => word.trim())
                            .join(",")
                        )}
                    >
                      {item?.formatted_address
                        ?.filter((line) => line.trim() !== "")
                        .join(", ")}
                    </option>
                  ))}
                </Field>
                {touched.address && errors.address && (
                  <div className="error-message">{errors.address}</div>
                )}
              </Form.Group>

              {/* Link to Search Another Way */}
              <div className="step-link-step" onClick={handleSwithCases}>
                <Link to="">Not found? Search another way</Link>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default EnquiryNine;
